<!-- Metti questo PRIMA del <nav>, in cima al file -->
<ng-template #notifDropdown>
  <div class="notif-dropdown" *ngIf="notifOpen">
    <div class="notif-header">
      <span class="notif-title">{{ "navbar.notifications" | translate }}</span>
      <button
        class="notif-read-all"
        *ngIf="notif.unreadCount > 0"
        (click)="markAllRead()"
      >
        {{ "navbar.mark_all_read" | translate }}
      </button>
    </div>

    <!-- Stato loading -->
    <div class="notif-empty" *ngIf="notif.loading">
      <span class="notif-spinner"></span>
    </div>

    <!-- Stato vuoto -->
    <div
      class="notif-empty"
      *ngIf="!notif.loading && notif.notifications.length === 0"
    >
      {{ "navbar.no_notifications" | translate }}
    </div>

    <div class="notif-list" *ngIf="!notif.loading && notif.notifications.length > 0">
      <div
        *ngFor="let n of notif.notifications"
        class="notif-item"
        [class.unread]="!n.read"
        (click)="markRead(n)"
      >
        <span class="notif-icon"><app-icon [name]="getNotifIcon(n.type)" [size]="18" /></span>
        <div class="notif-body">
          <p class="notif-item-title">{{ n.title }}</p>
          <p class="notif-item-msg">{{ n.message }}</p>
          <span class="notif-time">{{
            n.createdAt | date: "dd/MM/yyyy HH:mm"
          }}</span>
        </div>
        <span class="notif-dot" *ngIf="!n.read"></span>
      </div>
    </div>
  </div>
</ng-template>
<nav class="navbar">
  <div class="nav-left">
    <a routerLink="/home" class="nav-brand">
      <img src="nyzed-nav-logo.png" alt="" class="nav-brand-logo" />
      Nyzed
    </a>

    <button class="hamburger" [class.open]="menuOpen" (click)="toggleMenu()">
      <span></span>
      <span></span>
      <span></span>
    </button>

    <div class="links" [class.open]="menuOpen">
      <a
        routerLink="/home"
        class="nav-link"
        routerLinkActive="active"
        (click)="closeMenu()"
      >
        {{ "navbar.home" | translate }}
      </a>
      <a
        routerLink="/calendario"
        class="nav-link"
        routerLinkActive="active"
        (click)="closeMenu()"
      >
        {{ "navbar.calendar" | translate }}
      </a>
      <a
        id="tour-eventi"
        routerLink="/eventi"
        class="nav-link"
        routerLinkActive="active"
        (click)="closeMenu()"
      >
        {{ "navbar.wedding" | translate }}
      </a>
      <a
        routerLink="/contratti"
        class="nav-link"
        routerLinkActive="active"
        (click)="closeMenu()"
      >
        {{ "navbar.contracts" | translate }}
      </a>
      <a
        routerLink="/listino"
        class="nav-link"
        routerLinkActive="active"
        (click)="closeMenu()"
      >
        {{ "navbar.pricelist" | translate }}
      </a>
      <a
        routerLink="/statistiche"
        class="nav-link"
        routerLinkActive="active"
        (click)="closeMenu()"
      >
        {{ "navbar.statistics" | translate }}
      </a>
      <a
        routerLink="/collaborazioni"
        class="nav-link"
        routerLinkActive="active"
        (click)="closeMenu()"
      >
        {{ "navbar.collaborations" | translate }}
      </a>
    </div>
  </div>

  <!-- CLUSTER: campanella + avatar account (condiviso desktop/mobile) -->
  <div class="nav-cluster">
    <div class="notif-wrapper">
      <button id="tour-notifiche" class="notif-btn" (click)="toggleNotif()">
        <app-icon name="bell" [size]="20" />
        <span class="notif-badge" *ngIf="notif.unreadCount > 0">
          {{ notif.unreadCount > 9 ? "9+" : notif.unreadCount }}
        </span>
      </button>
      <ng-container *ngTemplateOutlet="notifDropdown"></ng-container>
    </div>

    <div class="avatar-menu" [class.open]="accountOpen">
      <button id="tour-profilo" class="avatar-btn" (click)="toggleAccount()">
        <img
          *ngIf="avatarUrl && !avatarError"
          [src]="avatarUrl"
          (error)="avatarError = true"
          class="avatar-img"
          alt="avatar"
        />
        <span *ngIf="!avatarUrl || avatarError" class="avatar-initials"><ng-container *ngIf="initials; else noInitials">{{ initials }}</ng-container><ng-template #noInitials><app-icon name="user" [size]="18" /></ng-template></span>
      </button>
      <div class="avatar-dropdown" *ngIf="accountOpen">
        <div class="account-greeting" *ngIf="userName">
          {{ "navbar.hello" | translate }} {{ userName }}
        </div>
        <a routerLink="/profilo" (click)="accountOpen = false" class="account-option">
          {{ "navbar.profile" | translate }}
        </a>
        <a routerLink="/impostazioni" (click)="accountOpen = false" class="account-option">
          <app-icon name="settings" [size]="16" /> {{ "navbar.settings" | translate }}
        </a>
        <a routerLink="/abbonamenti" (click)="accountOpen = false" class="account-option">
          <app-icon name="card" [size]="16" /> Abbonamento
        </a>
        <a *ngIf="isAdmin" routerLink="/admin" (click)="accountOpen = false" class="account-option">
          <app-icon name="shield" [size]="16" /> Admin Panel
        </a>
        <a routerLink="/feedback" (click)="accountOpen = false" class="account-option">
          {{ "navbar.feedback" | translate }} <span class="beta-badge">BETA</span>
        </a>
        <div class="account-lang">
          <button class="mobile-lang-btn" [class.active]="currentLang === 'it'" (click)="changeLang('it')">IT</button>
          <button class="mobile-lang-btn" [class.active]="currentLang === 'en'" (click)="changeLang('en')">EN</button>
          <button class="mobile-lang-btn" [class.active]="currentLang === 'es'" (click)="changeLang('es')">ES</button>
        </div>
        <button (click)="logout()" class="account-option logout">
          <app-icon name="logout" [size]="16" /> {{ "navbar.logout" | translate }}
        </button>
      </div>
    </div>
  </div>

</nav>
